import React from 'react';

export default function Loader({ fullscreen = false, overlay = false, text = 'Loading…' }) {
	if (fullscreen) {
		return (
			<div className="fixed inset-0 z-[9998] flex items-center justify-center bg-white/70">
				<div className="flex flex-col items-center">
					<div className="animate-spin rounded-full h-16 w-16 border-4 border-[#E5E7EB] border-t-[#180A63]"></div>
					{Boolean(text) && (
						<p className="mt-4 text-dark-blue text-sm font-medium">{text}</p>
					)}
				</div>
			</div>
		);
	}

	if (overlay) {
		return (
			<div className="absolute inset-0 z-[9998] flex items-center justify-center bg-white/70">
				<div className="flex flex-col items-center">
					<div className="animate-spin rounded-full h-12 w-12 border-4 border-[#E5E7EB] border-t-[#180A63]"></div>
					{Boolean(text) && (
						<p className="mt-3 text-dark-blue text-sm font-medium">{text}</p>
					)}
				</div>
			</div>
		);
	}

	return (
		<div className="flex items-center gap-2 text-dark-blue">
			<div className="animate-spin rounded-full h-5 w-5 border-2 border-[#E5E7EB] border-t-[#180A63]"></div>
			{Boolean(text) && <span className="text-sm">{text}</span>}
		</div>
	);
}
